import { Image } from '@mui/icons-material';
import { Box, Button, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { colors } from '../../assets/utils/colors';
import CustomeFileForm from '../../components/forms/CustomeFileForm';
import CustomeMultlineForm from '../../components/forms/CustomeMultlineForm';
import CustomTextField from '../../components/forms/CustomTextField';
import * as Yup from 'yup';

// ################### validation schema ###############
const createBrandSchema = Yup.object({
    brand_name: Yup.string().required('Brand name is required'),
    brand_description: Yup.string().required('Brand description is required'),
    file: Yup.mixed().required('Brand image is required'),
});

const CreateBrand = () => {
    // -> handle file preview
    const [filePreview, setFilePreview] = useState('');
    return (
        <>
            <Formik
                enableReinitialize
                initialValues={{
                    brand_name: '',
                    file: '',
                    brand_description: '',
                }}
                validationSchema={createBrandSchema}
            >
                {(formik) => (
                    <Form>
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid item sm={7} sx={{ mt: 2 }}>
                                <Box
                                    sx={{
                                        height: 225,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 5,
                                        background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor1})`,
                                    }}
                                >
                                    {filePreview ? (
                                        <>
                                            <img
                                                src={filePreview}
                                                alt="img"
                                                style={{
                                                    width: '100%',
                                                    height: '10em',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <Image
                                                sx={{
                                                    width: '100%',
                                                    height: '7em',
                                                    objectFit: 'contain',
                                                    opacity: 0.7,
                                                }}
                                            />
                                        </>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item sm={5}>
                                <CustomeFileForm
                                    name="brand_image"
                                    label={'Brand image'}
                                    type="file"
                                    color="primary"
                                    setFilePreview={setFilePreview}
                                    formik={formik}
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <CustomTextField
                                    name="brand_name"
                                    label={'Brand name'}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <CustomeMultlineForm
                                    name="brand_description"
                                    label={'Brand description'}
                                    color="primary"
                                    rows={5}
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        className="app-btn"
                                        onClick={formik.handleSubmit}
                                    >
                                        Create brand
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default CreateBrand;
